export default (error) => {
  // return a friendly message instead of the api error
  let readableError
  switch (error) {
    case 'messageId not found':
      readableError = 'Sorry, there was a problem with that message, please try again.'
      break
    case 'Multipart: Boundary not found':
      readableError = 'Attachment could not be uploaded, please try again.'
      break
    case 'unauthorized access':
      readableError = 'Sorry you are not authorized to perform the request.'
      break
    case 'participant already exists':
    case 'participant in project':
      readableError = 'This user is already a participant of this project. Please try a different user.'
      break
    case 'reCAPTCHA token missing':
      readableError = 'Please click on the reCAPTCHA checkbox to regenerate your login token.'
      break
    // New standardized error types
    case 'validation_error':
      readableError = 'Invalid participant data provided. Please check required fields.'
      break
    case 'existing_subscriber':
      readableError = 'Cannot add participant to an existing subscriber account. Please contact support for assistance.'
      break
    case 'domain_mismatch':
      readableError = 'Email domain does not match the specified organization. Please verify the correct organization.'
      break
    case 'already_exists':
      readableError = 'This participant already exists in the project or distribution list.'
      break
    case 'processing_error':
      readableError = 'An error occurred while processing participant data. Please try again.'
      break
    case 'insert_error':
    case 'insert_validation_error':
      readableError = 'Failed to save participant to database. Please check all required fields and try again.'
      break
    case 'organization_mismatch':
      readableError = 'Organization cannot accept new participants at this time. Please contact your administrator.'
      break
    case 'user_resolution_error':
      readableError = 'Unable to resolve user information. Please verify the participant details.'
      break
    case 'duplicate_email':
      readableError = 'Duplicate email address found in the import data.'
      break
    case 'region_validation_error':
      readableError = 'Invalid location information (country, state, city, or zip code).'
      break
    case 'permission_error':
      readableError = 'You do not have permission to add participants. Please contact your administrator.'
      break
    case 'database_error':
      readableError = 'Database error occurred. Please try again later or contact support.'
      break
    case 'network_error':
      readableError = 'Network error occurred. Please check your connection and try again.'
      break
    default:
      readableError = 'Sorry, an error occurred processing your request.'
      break
  }
  return readableError
}
